import { render } from "./WordBuilder.vue?vue&type=template&id=5b50c360"
import script from "./WordBuilder.vue?vue&type=script&lang=js"
export * from "./WordBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__